// Roboto font - self-hosted via @fontsource
import "@fontsource/roboto/300.css"; // Light
import "@fontsource/roboto/400.css"; // Regular
import "@fontsource/roboto/500.css"; // Medium
import "@fontsource/roboto/700.css"; // Bold
import "@fontsource/roboto/400-italic.css"; // Italic
import "@fontsource/roboto-condensed/400.css"; // Roboto Condensed Regular

import "@identitybuilding/idb-react-ui-elements/dist/styles/Colors.css";
import "./assets/css/App.css";
import {
  BrowserRouter,
  Route,
  Switch,
  useHistory,
  Redirect,
} from "react-router-dom";
import Main from "./components/Main";
import DetailsPage from "./components/DetailsPage";
import Login from "./components/Login";
import InfoSlider from "./components/InfoSlider";
import Meta from "./components/Meta";
// import SavedPage from "./pages/SavedPage";
// import FollowingPage from "./pages/FollowingPage"
// import ShoppingList from "./pages/ShoppingList"
// import PasswordReset from "./pages/PasswordReset"
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { useEffect } from "react";
import CookieMessage from "./components/CookieMejsxssage";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";

import FollowingConflict from "./components/FollowingConflict";
import {
  updateAccountInfo,
  toggleLoginScreen as toggleLoginScreenAction,
} from "./actions/index";
import PasswordReset from "./pages/PasswordReset";
import AccountSettings from "./pages/AccountSettings";
import PreferencesPage from "./pages/PreferencesPage";
import BosuitbreidingPage from "./components/BosuitbreidingPage";
import axios from "axios";
import { useRef } from "react";
import { getEnvEndpoints } from "./utils/functions";

const App = () => {
  const { translate, lang } = useSelector((state) => state.general);
  const loginRef = useRef(null); // Ref for Login modal container
  const accountData = useSelector((state) => state.account.accountData); // Determine if logged in
  const { followState } = useSelector((state) => state.account);
  const isLoggedIn = useSelector((state) => state.account.isLoggedIn);
  const env = getEnvEndpoints();
  const { loginScreen, openFollowingConflict, infoSliderOpen } = useSelector(
    (state) => state.account
  );
  const dispatch = useDispatch();
  const toggleLoginScreen = () => {
    dispatch(toggleLoginScreenAction(false)); // Ensure proper dispatch of action
  };
  let page_slug = translate("page").toLowerCase();
  const routeMap = {
    nl: { collaboration: "/actieve-gemeenten", following: "/wie-volg-ik" },
    fr: { collaboration: "/communes-actives", following: "/mes-suivis" },
    en: { collaboration: "/active-municipalities", following: "/who-i-follow" },
    de: { collaboration: "/aktive-gemeinden", following: "/wer-folge-ich" },
  };
  const routePath_HasCollaboration = routeMap[lang]?.collaboration || routeMap.nl.collaboration;
  const routePath_Following = routeMap[lang]?.following || routeMap.nl.following;
  const allCollaborationPaths = Object.values(routeMap).map(r => r.collaboration);
  const allFollowingPaths = Object.values(routeMap).map(r => r.following);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (loginRef.current && !loginRef.current.contains(event.target)) {
        toggleLoginScreen(); // Close the login modal
        const mapDrawer = document.querySelector(".mapDrawer");
        if (mapDrawer) {
          mapDrawer.classList.remove("blurred"); // Remove the blur
        }
      }
    };

    if (loginScreen) {
      document.addEventListener("mousedown", handleClickOutside);
      const mapDrawer = document.querySelector(".mapDrawer");
      if (mapDrawer) {
        mapDrawer.classList.add("blurred"); // Add the blur when modal is open
      }
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      const mapDrawer = document.querySelector(".mapDrawer");
      if (mapDrawer) {
        mapDrawer.classList.remove("blurred"); // Remove the blur
      }
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [loginScreen]);

  const getData = () => {
    if (localStorage.getItem("StadGemeenteToken")) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${localStorage.getItem("StadGemeenteToken")}`,
      };
      axios
        .get(
          `${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/user/?lang=${lang}`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          let copy = res.data;
          const today = new Date(); // current date
          const filteredArray = copy.saved_cmps.filter((item) => {
            // Parse date strings in "DD-MM-YYYY" format
            const parseDate = (dateString) => {
              const [day, month, year] = dateString.split("-").map(Number);
              return new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Dates
            };

            const visibleEnd = parseDate(item.visible_end.substr(0, 10));

            // Calculate two weeks after visible_end
            const twoWeeksAfterEnd = new Date(visibleEnd);
            twoWeeksAfterEnd.setDate(visibleEnd.getDate() + 14);

            // Check if today is within two weeks after visible_end
            return today <= twoWeeksAfterEnd;
          });
          copy.saved_cmps = filteredArray;

          dispatch(updateAccountInfo(res.data));
        });
    }
  };

  const RootRedirect = () => {
    if (isLoggedIn) {
      return <Redirect to={routePath_Following} />; // Redirect to the "follow" page if logged in
    }
    return <Redirect to={routePath_HasCollaboration} />; // Redirect to a public page if not logged in
  };

  useEffect(() => {
    // if(window.location.hostname !== 'localhost' && (!window.location.href.includes('mijn') || !window.location.href.includes('ma'))) {
    //   if (window.location.hostname.includes('stad-gemeente')){
    //     window.location.href = `https://mijn.stad-gemeente.be${window.location.pathname}`
    //   }
    //   else {
    //     window.location.href = `https://mijn.stad-gemeente.be${window.location.pathname}`
    //   }
    // }
    if (window.location.hostname !== "localhost") {
      if (window.location.hostname.includes("stadt-gemeinde.be")) {
        // DE: no prefix redirect needed
      } else if (window.location.hostname.includes("stad-gemeente.be")) {
        if (!window.location.hostname.includes("mijn")) {
          window.location.href = `https://mijn.stad-gemeente.be${window.location.pathname}`;
        }
      } else if (window.location.hostname.includes("ville-commune.be")) {
        if (!window.location.hostname.includes("ma")) {
          window.location.href = `https://ma.ville-commune.be${window.location.pathname}`;
        }
      } else if (window.location.hostname.includes("city-municipality.be")) {
        // EN: no prefix redirect needed
      }
    }

    getData();
  }, []);

  const createNotification = (type, message) => {
    if (type === "info") {
      NotificationManager.info(message);
    } else if (type === "success") {
      NotificationManager.success(message);
    } else if (type === "warning") {
      NotificationManager.warning(message);
    } else if (type === "error") {
      NotificationManager.error(message);
    }
  };

  return (
    <div className="App">
      <NotificationContainer />
      <BrowserRouter>
        <Meta />
        {loginScreen && (
          <div ref={loginRef}>
            {" "}
            <Login
              createNotification={createNotification}
              toggleLoginScreen={toggleLoginScreen}
            />{" "}
          </div>
        )}

        {infoSliderOpen && <InfoSlider />}

        {openFollowingConflict && (
          <FollowingConflict
            createNotification={createNotification} // Pass the createNotification function here
            setShare={() => {}} // Ensure setShare is passed if needed
          />
        )}

        <CookieMessage />
        <Switch>
          {/* <Route exact path="/" render={(props) => <Main {...props} dispatch={dispatch} toggleLoginScreen={toggleLoginScreen} loggedIn={!!accountData} login={toggleLoginScreen} />} /> */}
          <Route exact path="/">
            <RootRedirect />
          </Route>
          ;
          {/* <Route exact path="/volgende" render={(props) => <Main {...props} dispatch={dispatch} toggleLoginScreen={toggleLoginScreen} loggedIn={!!accountData} login={toggleLoginScreen} followState={true} />} /> */}
          <Route
            exact
            path={allCollaborationPaths}
            render={(props) => (
              <Main
                {...props}
                dispatch={dispatch}
                toggleLoginScreen={toggleLoginScreen}
                loggedIn={!!accountData}
                login={toggleLoginScreen}
                followState={false}
              />
            )}
          />
          <Route
            exact
            path={allFollowingPaths}
            render={(props) =>
              isLoggedIn ? (
                <Main
                  {...props}
                  dispatch={dispatch}
                  toggleLoginScreen={toggleLoginScreen}
                  loggedIn={!!accountData}
                  login={toggleLoginScreen}
                  followState={true}
                />
              ) : (
                <Redirect to="/actieve-routePath_HasCollaboration" />
              )
            }
          />
          <Route
            path="/reset_password/:token/"
            render={(props) => (
              <PasswordReset
                {...props}
                createNotification={createNotification}
              />
            )}
          />
          {/* Account Settings Routes (NL and FR) */}
          <Route
            path={["/account-instellingen", "/parametres-du-compte", "/account-settings", "/kontoeinstellungen"]}
            render={(props) => (
              <AccountSettings
                {...props}
                createNotification={createNotification}
              />
            )}
          />
          {/* Preferences Page (WIE VOLG IK) — multi-language paths */}
          <Route
            path={["/voorkeuren", "/mes-preferences", "/my-preferences", "/einstellungen"]}
            render={(props) => (
              <PreferencesPage
                {...props}
                createNotification={createNotification}
              />
            )}
          />
          <Route
            path={["/bosuitbreiding", "/bosuitbreiding-particulier", "/bosuitbreiding-onderneming"]}
            render={(props) => (
              <BosuitbreidingPage
                {...props}
                createNotification={createNotification}
              />
            )}
          />
          <Route
            path="/:municipality"
            render={(props) => <DetailsPage {...props} />}
          />
          {/* <Route path="/saves/" render={(props) => <SavedPage {...props} createNotification={createNotification} />} />
          <Route path="/following/" render={(props) => <FollowingPage {...props} createNotification={createNotification} />} />
          <Route path="/shoppinglist/" render={(props) => <ShoppingList {...props} createNotification={createNotification} />} />
          <Route path="/reset_password/:token/" render={(props) => <PasswordReset {...props} createNotification={createNotification} />} /> */}
        </Switch>
      </BrowserRouter>
    </div>
  );
};

export default App;
